import { FC } from "react";
import s from "./style.module.css";

export const Subhead: FC<{ label: string }> = ({ label }) => {
  return <h2 className={s.subhead}>{label}</h2>;
};
